export const SET_TENANT_DATA = "SET_TENANT_DATA";
export const PORTAL_TENANT_FETCHING_INIT = "PORTAL_TENANT_FETCHING_INIT";
export const PORTAL_TENANT_FETCHING_COMPLETE =
  "PORTAL_TENANT_FETCHING_COMPLETE";
export const PORTAL_TENANT_FETCHING_DISMISS = "PORTAL_TENANT_FETCHING_DISMISS";
export const NORMAL_TENANT_FETCHING_INIT = "NORMAL_TENANT_FETCHING_INIT";
export const NORMAL_TENANT_FETCHING_COMPLETE =
  "NORMAL_TENANT_FETCHING_COMPLETE";
export const NORMAL_TENANT_FETCHING_DISMISS = "NORMAL_TENANT_FETCHING_DISMISS";
export const CHANGE_PORTAL_PAGE = "CHANGE_PORTAL_PAGE";
export const CHANGE_NORMAL_PAGE = "CHANGE_NORMAL_PAGE";
export const LOAD_COUNTRY_LIST = "LOAD_COUNTRY_LIST";
export const LOAD_LANGUAGE_INDUSTRY_LIST = "LOAD_LANGUAGE_INDUSTRY_LIST";
export const LOAD_DISTRIBUTOR_LIST = "LOAD_DISTRIBUTOR_LIST";
export const LOAD_PARENT_COMPANY_LIST = "LOAD_PARENT_COMPANY_LIST";
export const LOAD_STATUS_LIST = "LOAD_STATUS_LIST";
export const LOAD_INVITE_PARTNER_OPTIONS = "LOAD_INVITE_PARTNER_OPTIONS";
export const ADD_NEW_TENANT = "ADD_NEW_TENANT";
export const ADD_NEW_TENANT_INIT = "ADD_NEW_TENANT_INIT";
export const ADD_NEW_TENANT_ERROR = "ADD_NEW_TENANT_ERROR";
export const ADD_NEW_TENANT_PREVIEW = "ADD_NEW_TENANT_PREVIEW";
export const ADD_NEW_TENANT_DISMISS = "ADD_NEW_TENANT_DISMISS";
export const EDIT_TENANT_PREVIEW = "EDIT_TENANT_PREVIEW";
export const EDIT_TENANT_ERROR = "EDIT_TENANT_ERROR";
export const EDIT_TENANT_INIT = "EDIT_TENANT_INIT";
export const EDIT_TENANT = "EDIT_TENANT";
export const EDIT_TENANT_DISMISS = "EDIT_TENANT_DISMISS";
export const DELETE_TENANT_PREVIEW = "DELETE_TENANT_PREVIEW";
export const DELETE_TENANT_DISMISS = "DELETE_TENANT_DISMIS";
export const DELETE_TENANT = "DELETE_TENANT";
export const DISABLE_TENANT_PREVIEW = "DISABLE_TENANT_PREVIEW";
export const DISABLE_TENANT_DISMISS = "DISABLE_TENANT_DISMISS";
export const DISABLE_TENANT = "DISABLE_TENANT";
export const SEARCH_PORTAL_TENANT = "SEARCH_PORTAL_TENANT";
export const SEARCH_NORMAL_TENANT = "SEARCH_NORMAL_TENANT";
export const SET_PORTAL_SETTINGS_DATA = "SET_PORTAL_SETTINGS_DATA";
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_ALL_ACTIVE_REPORT_TYPE = "SET_ALL_ACTIVE_REPORT_TYPE";
export const LOAD_CURRENCY_CODES = "LOAD_CURRENCY_CODES";
export const GET_NEW_PARTNERS_INIT = "GET_NEW_PARTNERS_INIT";
export const SEARCH_NEW_PARTNER = "SEARCH_NEW_PARTNER";
